import { cn, formatDecimal } from '@/lib/utils';

interface ProgressBarProps {
  value: number; // 0-100
  className?: string;
  showLabel?: boolean;
}

export function ProgressBar({ value, className, showLabel = true }: ProgressBarProps) {
  const clampedValue = Math.min(100, Math.max(0, value));
  const overTarget = value > 100;

  return (
    <div className={cn('w-full', className)}>
      <div className="relative h-4 w-full rounded-full bg-adv-border overflow-hidden">
        <div
          className={cn(
            'h-full rounded-full transition-all duration-300',
            overTarget && 'bg-adv-success'
          )}
          style={{
            width: `${clampedValue}%`,
            background: overTarget ? undefined : 'var(--chart-1-gradient)',
          }}
        />
      </div>
      {showLabel && (
        <div className="mt-1 flex justify-between text-adv-body-s text-adv-secondary">
          <span>
            <span className="adv-num">{formatDecimal(value, 1)}%</span> completed
          </span>
          {overTarget && <span className="font-bold text-adv-success">Over target!</span>}
        </div>
      )}
    </div>
  );
}
